import styled from "styled-components";

export const CouponInputContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: 12px;
`;

export const CounterContainer = styled.div``;

export const CurrencyInputContainer = styled.div``;
